import PageHeader from "@/components/PageHeader";
import HealthcareNewsFeed from "@/components/HealthcareNewsFeed";

export default function HealthcareNews() {
  return (
    <div data-testid="page-healthcare-news">
      <PageHeader
        overline="AI-Curated · Refreshed every 12 hours"
        title="Healthcare News"
        italic="Dashboard."
        description="A live, AI-curated feed pulling from CMS, KFF, Medicare/Medicaid, home-health, NEMT, and policy sources. Every headline links directly to the original article — no opinions, just signal."
      />
      <HealthcareNewsFeed compact={false} />
    </div>
  );
}
